exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-43f74820] {\r\n    font-size: 16px;\n}\n.pageBox[data-v-43f74820] {\r\n    width: 100vw;\r\n    overflow-x: hidden;\r\n    min-height: 100vh;\n}\r\n", ""]);

// exports
